import { render, staticRenderFns } from "./PatientSmsButton.vue?vue&type=template&id=2f21c3a8&scoped=true"
import script from "./PatientSmsButton.vue?vue&type=script&lang=js"
export * from "./PatientSmsButton.vue?vue&type=script&lang=js"
import style0 from "./PatientSmsButton.vue?vue&type=style&index=0&id=2f21c3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21c3a8",
  null
  
)

export default component.exports